import toast from "react-hot-toast";
export { toast };
